<template lang="pug">
.modal.active
  a.modal-overlay(@click="close")
  .modal-container
    .modal-header
      a.btn.btn-clear.float-right(@click="close")
      .modal-title.h5 {{modalTitle}}
    .modal-body
      .content
        .divider
        .columns
          .column.col-6.col-sm-12
            form-group(label="Título" :validation="$v.productItem" field="title")
              input.form-input(v-model.trim="$v.productItem.title.$model")
          .column.col-6.col-sm-12
            form-group(label="Preço")
              masked-money.form-input(v-model="productItem.price" v-bind="valueAttrs")
        .divider
        .columns
          .column.col-6.col-sm-12
            form-group(label="Data de publicação")
              datepicker(v-model="productItem.publishDate")
          .column.col-6.col-sm-12
            form-group(label="Categoria")
              select.form-select(v-model="productItem.category")
                option(value="")
                option(v-for="(category, key) in categories" :value="key") {{category}} 
          .column.col-12
            form-group(label="Resumo")
              quill-editor(v-model="productItem.brief" rows="3")
          .column.col-12
            form-group(label="Texto do conteúdo")
              quill-editor(v-model="$v.productItem.contentText.$model" rows="5" placeholder="Texto do conteúdo")
        .divider
        .columns
          .column.col-12
            form-group(label="Capa")
              file-upload(
                v-model="productItem.cover"
                @upload-start="uploading = true"
                @upload-end="uploading = false"
              )
        .divider
        .columns
          .column.col-6.col-sm-12
            form-switch(v-model="productItem.customerCourtesy" label="Cortesia para clientes")
          .column.col-6.col-sm-12
            form-switch(v-model="productItem.subscriberCourtesy" label="Cortesia para assinantes")
        .divider
        .columns
          .column.col-12
            form-group(label="Autores" :validation="$v.productItem" field="authors")
              authors-autocomplete(v-model="productItem.authors")
          .column.col-12
            form-group(label="Palavras-chave")
              keywords-autocomplete(v-model="productItem.keywords")
        .divider
        .columns
          .column.col-12
            form-group(label="DOI link" :validation="$v.productItem" field="doiLink")
              input.form-input(v-model="$v.productItem.doiLink.$model")
        .divider.text-center(data-content="Itens customizados")
        data-form(v-model="$v.productItem.data.$model")
        .divider
        .columns
          .column.col-6.col-sm-12
            form-group(label="Idioma" :validation="$v.productItem" field="language")
              select.form-select(v-model="$v.productItem.language.$model")
                option(v-for="(language, key) in languages" :value="key") {{language}}
          .column.col-6.col-sm-12
            form-group(label="Capítulo" :validation="$v.productItem" field="chapterNumber")
              the-mask.form-input(v-model="$v.productItem.chapterNumber.$model" mask="###")
          .column.col-6.col-sm-12(v-if="productType === 'course'")
            form-group(label="Tipo de arquivo" :validation="$v.productItem" field="fileType")
              select.form-select(v-model="$v.productItem.fileType.$model")
                option(:value="null")
                option(v-for="(fileType, key) in fileTypes" :value="key") {{fileType}}
        .columns(v-if="productType !== 'video' && productType !== 'course'")
          .column.col-6.col-sm-12
            form-group(label="Página inicial" :validation="$v.productItem" field="initialPage")
              input.form-input(type="number" v-model.number="$v.productItem.initialPage.$model")
          .column.col-6.col-sm-12
            form-group(label="Quantidade de páginas" :validation="$v.productItem" field="length")
              input.form-input(type="number" v-model.number="$v.productItem.length.$model")
        .columns(v-if="!file")
          .column.col-12
            form-group(label="Conteúdo" :validation="$v.productItem" field="content")
              content-upload(v-model="$v.productItem.content.$model" @file-format-update="updateFileFormat")
        pdf-preview(:file="file" :initial-page="productItem.initialPage" :pages="productItem.length")
    .modal-footer
      button.btn.btn-primary(:disabled="$v.$invalid" @click="submitProductItemForm" type="button") Salvar
</template>

<script>
import { required, requiredIf, url } from 'vuelidate/lib/validators'
import categories from '@/lib/products/categories'
import languages from '@/lib/products/languages'
import fileTypes from '@/lib/products/fileTypes'
import ContentUpload from '@/views/products/components/ContentUpload'
import PdfPreview from './PdfPreview.vue'
import DataForm from '@/views/products/components/DataForm.vue'

export default {
  data() {
    return {
      categories,
      languages,
      fileTypes,
      disabled: false,
      uploading: false,
    }
  },

  props: {
    productItem: { type: Object, required: true },
    productType: { type: String, required: true },
    file: { type: File },
  },

  components: { ContentUpload, PdfPreview, DataForm },

  computed: {
    showPreview() {
      return (
        this.file &&
        this.$v.productItem.initialPage.$model &&
        this.$v.productItem.length.$model &&
        this.productItem.fileFormat === 'pdf'
      )
    },
    modalTitle() {
      const map = {
        book: 'Novo capítulo',
        magazine: 'Novo artigo',
        video: 'Novo vídeo',
        course: 'Novo item',
        divulgation: 'Nova divulgação',
      }

      return map[this.productType]
    },

    valueAttrs() {
      return { prefix: 'R$ ' }
    },
  },

  methods: {
    close() {
      this.$emit('close-modal')
    },

    updateFileFormat(fileFormat) {
      this.productItem.fileFormat = fileFormat

      if (this.productType === 'course' || this.productType === 'divulgation') {
        const videoFormats = ['mp4', 'mov', 'wmv', 'avi']
        const imageFormats = ['tiff', 'jpeg', 'jpg', 'png', 'gif', 'bmp']

        if (fileFormat === 'pdf') {
          this.productItem.fileType = fileFormat
        } else if (videoFormats.includes(fileFormat)) {
          this.productItem.fileType = 'video'
        } else if (imageFormats.includes(fileFormat)) {
          this.productItem.fileType = 'image'
        } else {
          this.productItem.fileType = null
        }
      }
    },

    submitProductItemForm() {
      this.$emit('submit-form', this.productItem)
    },
  },
  created() {
    this.productItem.content = this.file
    this.productItem.publishDate = new Date()
    const name = this.file.name
    const lastDot = name.lastIndexOf('.')

    const extension = name.substring(lastDot + 1)
    this.updateFileFormat(extension)
  },

  validations: {
    productItem: {
      title: { required },
      doiLink: { url },
      data: {},
      contentText: {},
      initialPage: {
        required: requiredIf(function() {
          return this.productType !== 'video' && this.productType !== 'course'
        }),
      },
      chapterNumber: {
        required: requiredIf(function() {
          return this.productType === 'book'
        }),
      },
      language: { required },
      fileFormat: { required },
      content: { required },
      authors: { required },
      length: {
        required: requiredIf(function() {
          return this.productType !== 'video' && this.productType !== 'course'
        }),
      },
      fileType: {
        required: requiredIf(function() {
          return this.productType === 'course'
        }),
      },
    },
  },
}
</script>
